import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {}
})

export default class SplitPanelView extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};
        this.element = this.$el.get(0);
    }

    onRender() {
        this.resize();
        window.addEventListener('resize', () => {
            this.resize();
        });
    }

    resize() {
        if(!this.element.classList.contains('split-panel--non-overlay')) {

            let media = this.element.querySelector('.panel--media');
            let content = this.element.querySelector('.panel--media');

            let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)


            let multiplier = 0.5;
            if (w > 600) {
                multiplier = 0.25;
            }
            if (w > 991) {
                multiplier = 0;
            }

            media.style.marginBottom = content.getBoundingClientRect().height * multiplier + 'px';
        }
    }
}




// WEBPACK FOOTER //
// ./@modules/views/split-panel-view.ts